import { render, staticRenderFns } from "./CustomAutocomplete.vue?vue&type=template&id=a0c031a0&lang=pug&"
import script from "./CustomAutocomplete.vue?vue&type=script&lang=js&"
export * from "./CustomAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports